<template>
    <div v-fs-block>
        <iframe
            ref="iframe"
            frameborder="0"
            allowtransparency="true"
            style="width: 100%"
            :sandbox="sandbox"
            :srcdoc="html"
            scrolling="no"
            @load="resizeBodyIFrame">
        </iframe>
    </div>
</template>
<script>
    import highlightjs from '@/vendor/highlight';

    export default {
        name: 'v-iframe-sandbox',
        props: {
            html: {
                type: String,
            },
            sandbox: { // allow-same-origin || allow-top-navigation || allow-forms || allow-scripts
                type: String,
                default: 'allow-same-origin',
            },
            highlight: {
                type: String,
            },
        },
        methods: {
            resizeBodyIFrame({target}) {
                const contentHeightCorrection = 32;
                const iFrameBody = target.contentWindow.document.body;
                const height = Math.max(target.contentWindow.document.documentElement.offsetHeight, target.contentWindow.document.body.scrollHeight);
                target.style.height = `${height + contentHeightCorrection}px`;
                target.style.margin = '1px';
                target.style.padding = '1px';
                iFrameBody.style.margin = '1px';
                iFrameBody.style.padding = '1px';

                if (this.highlight) {
                    const codeTags = target.contentWindow.document.querySelectorAll(this.highlight);
                    if (codeTags.length > 0) {
                        codeTags.forEach(el => highlightjs.highlightBlock(el));
                    }
                }
            },
            /**
             * Delegate triggered by external calls to recalculate the iframe size.
             */
            refresh() {
                this.resizeBodyIFrame({target: this.$refs.iframe});
            },
        },
    };
</script>
